export default "__VITE_ASSET__D$GdLUN2__"